
// reactstrap components
import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const Header = ({accountData}) => {
  console.log(accountData)
  return (
    <>
      <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"180px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                        Flow Balance
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {parseFloat(accountData?.availableBalance)?.toFixed(4)}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-chart-bar" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                         Total Balance : {parseFloat(accountData?.balance).toFixed(3)}
                      </span>{" "}
                      <br></br>
                      <span className="text-wrap text-red">Used Balance : {accountData && parseFloat(accountData?.balance - accountData?.availableBalance).toFixed(3)}</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"180px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Keys
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{accountData?.keys?.totalKeys}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-warning text-white rounded-circle shadow">
                          <i className="fas fa-chart-pie" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-success mr-2">
                        Active Keys : {accountData?.keys?.totalActiveKeys}
                      </span>{" "}
                      <br />
                      <span className="text-wrap text-danger"> Revoked Keys: {accountData?.keys?.totalRevokedKeys}</span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"180px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Storage
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{accountData && ((accountData?.storageCapacity - accountData?.storageUsed)/1024/1024)?.toFixed(2)}&nbsp;&nbsp;MB</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-yellow text-white rounded-circle shadow">
                          <i className="fas fa-users" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      <span className="text-primary mr-2">
                        Total Storage Capacity: {(accountData?.storageCapacity/1024/1024)?.toFixed(2)}&nbsp;&nbsp;MB
                      </span>{" "}
                      <span className="text-nowrap text-danger">
                        Used Storage: {(accountData?.storageUsed/1024/1024)?.toFixed(2)}&nbsp;&nbsp;MB
                      </span>
                    </p>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"180px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                          Contracts
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">{accountData?.contracts?.length}</span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow">
                          <i className="fas fa-percent" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      {/* <span className="text-success mr-2">
                        <i className="fas fa-arrow-up" /> 12%
                      </span>{" "}
                      <span className="text-nowrap">Since last month</span> */}
                    </p>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <Row className="mt-4 justify-content-center">
              <Col lg="6" xl="3">
                <Card className="card-stats mb-4 mb-xl-0" style={{"height":"180px"}}>
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h5"
                          className="text-uppercase text-muted mb-0"
                        >
                        Child Accounts
                        </CardTitle>
                        <span className="h2 font-weight-bold mb-0">
                          {accountData?.childAccounts?.length || 0}
                        </span>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-danger text-white rounded-circle shadow">
                          <i className="fas fa-chart-bar" />
                        </div>
                      </Col>
                    </Row>
                    <p className="mt-3 mb-0 text-muted text-sm">
                      {/* <span className="text-success mr-2">
                         Total Balance : {parseFloat(accountData?.balance).toFixed(3)}
                      </span>{" "}
                      <span className="text-wrap text-red">Used Balance : {accountData && parseFloat(accountData?.balance - accountData?.availableBalance).toFixed(3)}</span> */}
                    </p>
                  </CardBody>
                </Card>
              </Col>
              
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Header;
